import { CommentItem } from "../pages/Comments/models/comments.model";
import api from "./config/axios.config";

const companyId = 1;
const companyHeader = { companyId: companyId.toString() };

/** ===== Normalizador ===== */
function normalizeComment(raw: any): CommentItem {
  return {
    id: raw.id,
    comment: raw.comment,
    source: raw.source,
    userId: raw.userId ?? raw.user_id,
    userName: raw.userName ?? raw.user_name,
    createdAt: raw.createdAt ?? raw.created_at,
    updatedAt: raw.updatedAt ?? raw.updated_at,

    analysisId: raw.analysisId ?? raw.analysis_id,
    analysisFile:
      raw.analysisFile ??
      raw.analysis_file ??
      raw.analysis?.file ??
      raw.analysis?.pdf_file_name,
  };
}

/** ===== Service ===== */

export const getComments = async (
  filters: Partial<CommentItem> = {}
): Promise<CommentItem[]> => {
  try {
    const response = await api.get("/admin/comments", {
      params: filters,
      headers: companyHeader,
    });
    const data = response.data?.comments?.comments;

    if (Array.isArray(data)) {
      return data.map(normalizeComment);
    }

    if (data?.results) {
      return data.map(normalizeComment);
    }

    return [];
  } catch (error) {
    console.error("Error fetching comments:", error);
    return [];
  }
};

export const getCommentById = async (
  id: number | string
): Promise<CommentItem | null> => {
  try {
    const response = await api.get(`/comments/${id}`, { headers: companyHeader });
    return normalizeComment(response.data);
  } catch (error) {
    console.error("Error fetching comment by id:", error);
    return null;
  }
};

export const deleteComment = async (id: number | string): Promise<boolean> => {
  try {
    const response = await api.delete(`/admin/comments/${id}`, {
      headers: companyHeader,
    });
    return response.status === 200 || response.status === 204;
  } catch (error) {
    console.error("Error deleting comment:", error);
    return false;
  }
};

const commentsService = { getComments, getCommentById, deleteComment };
export default commentsService;
